// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/operational-pitfalls.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/operational-pitfalls/operational-pitfalls.js';

mount([g0]);
